<template>
  <el-dialog :title="$t('resourceStoreType.editType')" :visible.sync="dialogVisible" width="50%" @close="handleClose">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item :label="$t('resourceStoreType.typeName')" prop="name">
        <el-input v-model="form.name" :placeholder="$t('resourceStoreType.typeNamePlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('resourceStoreType.typeDesc')" prop="description">
        <el-input v-model="form.description" type="textarea" :placeholder="$t('resourceStoreType.typeDescPlaceholder')"
          :rows="4" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateResourceStoreType } from '@/api/housekeeping/resourceStoreTypeApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditResourceStoreType',
  data() {
    return {
      dialogVisible: false,
      form: {
        rstId: '',
        name: '',
        description: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('resourceStoreType.typeNameRequired'), trigger: 'blur' }
        ],
        description: [
          { max: 200, message: this.$t('resourceStoreType.typeDescMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.form = {
        rstId: row.rstId,
        name: row.name,
        description: row.description
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const params = {
              ...this.form,
              shopId: getShopId()
            }
            await updateResourceStoreType(params)
            this.$message.success(this.$t('common.submitSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            this.$message.error(error)
            console.error('修改失败:', error)
          }
        }
      })
    }
  }
}
</script>